<template>
    <div class="animated fadeIn">
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image tariff-splash" v-if="!isMobile()">
                                        <img alt="Pricing splash" src="./assets/pricing-splash.svg">
                                    </figure>
                                    <figure class="image tariff-splash mobile-screen" v-else>
                                        <img alt="Pricing splash" src="./assets/pricing-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile uptin-text-center">
                                    {{ $t('tariff:tariff.subtitle') }}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Calculation method section -->
        <section class="section is-background-gray1">
            <div class="padding-top-2x padding-bottom-2x">

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image tariff-page-img" v-if="!isMobile()">
                            <img alt="Free pricing" src="./assets/free-pricing.svg">
                        </figure>
                        <figure class="image tariff-page-img mobile-screen" v-else>
                            <img alt="Free pricing" src="./assets/free-pricing.svg">
                        </figure>
                    </div>
                </div>
                <div class="columns">
                    <div class="column intro-text content">
                        <h3 class="is-size-4 small-container padding-bottom-1x padding-top-2x uptin-text-center text-yellow"
                            v-html="$t('tariff:tariff.description_title')">
                        </h3>
                    </div>
                </div>
                <div class="columns">
                    <div class="column intro-text content small-container text-white">
                        <p class="is-size-6 small-container tariff-text uptin-text-center">
                            {{ $t('tariff:tariff.description_p1') }}
                        </p>
                        <p class="is-size-6 small-container padding-bottom-2x tariff-text uptin-text-center">
                            {{ $t('tariff:tariff.description_p2') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Tarrif section -->
        <section class="section  is-background-gray6">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered has-padding-2x">
                    <h2 class="title is-size-2 has-text-centered-mobile uptin-text-center">
                        {{ $t('tariff:tariff.title') }}
                    </h2>
                </div>

                <div class="columns is-centered">
                    <!--  Column 1 -->
                    <div class="column content column-center">
                        <div class="uptin-pricing-box">
                            <div class="column is-centered column-center" style="padding-top: 2em">
                                <h4 class="title is-size-4 has-text-centered-mobile uptin-text-center">
                                    {{ $t('tariff:free.title') }}
                                </h4>
                            </div>

                            <div class="column is-centered column-center">
                                <p class="uptin-text-center has-text-centered-mobile uptin-text-7 text-gray">
                                    {{ $t('tariff:free.comment') }}
                                </p>
                            </div>

                            <div class="column is-centered column-center has-padding-2x">
                                <p class="title is-size-4 uptin-text-center has-text-centered-mobile text-blue">
                                    {{ $t('tariff:free.price') }}
                                </p>
                                <p class="uptin-text-center is-size-7 has-text-centered-mobile text-blue">
                                    {{ $t('tariff:free.unit') }}
                                </p>
                            </div>

                            <div class="column is-centered column-center has-padding-2x is-centered-container">
                                <router-link :to="'get-app'" class="button uptin-splash-button is-background-dark3" active-class="is-active is-active--advertiser">
                                    {{ $t('tariff:free.button') }}
                                </router-link>
                            </div>

                            <div class="is-centered column-center has-border-bottom-gray">

                            </div>

                            <div class="columns include-style">
                                {{ $t('tariff:free.include') }}
                                <ul style="margin-top: 2em; margin-left: 0">
                                    <li class="uptin-text-6">{{ $t('tariff:free.f1') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f2') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f3') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f4') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f5') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f6') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f7') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f8') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f9') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f10') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f11') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:free.f12') }}</li>
                                </ul>
                            </div>

                            <div class="is-centered column-center has-border-bottom-gray">

                            </div>

                            <div class="column is-centered column-center has-padding-2x is-centered-container">
                                <router-link :to="'get-app'" class="button uptin-splash-button is-background-dark3" active-class="is-active is-active--advertiser">
                                    {{ $t('tariff:free.button') }}
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <!--  Column 2 -->
                    <div class="column content column-center">
                        <div class="uptin-pricing-box">
                            <div class="column is-centered column-center" style="padding-top: 2em">
                                <h4 class="title is-size-4 has-text-centered-mobile uptin-text-center">
                                    {{ $t('tariff:premium.title') }}
                                </h4>
                            </div>

                            <div class="column is-centered column-center">
                                <p class="uptin-text-center has-text-centered-mobile uptin-text-7 text-gray">
                                    {{ $t('tariff:premium.comment') }}
                                </p>
                            </div>

                            <div class="column is-centered column-center has-padding-2x">
                                <p class="title is-size-4 uptin-text-center has-text-centered-mobile text-green">
                                    {{ $t('tariff:premium.price') }}
                                </p>
                                <p class="uptin-text-center is-size-7 has-text-centered-mobile text-gray">
                                    {{ $t('tariff:premium.unit') }}
                                </p>
                            </div>

                            <div class="column is-centered column-center has-padding-2x is-centered-container">
                                <a href="https://panel.uptinptt.ir/signup"
                                   class="button uptin-splash-button is-background-blue">
                                    {{ $t('tariff:premium.button') }}
                                </a>
                            </div>

                            <div class="is-centered column-center has-border-bottom-gray">

                            </div>

                            <div class="columns include-style">
                                {{ $t('tariff:premium.include') }}
                                <ul style="margin-top: 2em; margin-left: 0">
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f1') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f2') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f3') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f4') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f5') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f6') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f7') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f8') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f9') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f10') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f11') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f12') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f13') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f14') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f15') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f16') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f17') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f18') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f19') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:premium.f20') }}</li>
                                </ul>
                            </div>

                            <div class="is-centered column-center has-border-bottom-gray">

                            </div>

                            <div class="column is-centered column-center has-padding-2x is-centered-container">
                                <a href="https://panel.uptinptt.ir/signup"
                                   rel="noopener"
                                   class="button uptin-splash-button is-background-blue">
                                    {{ $t('tariff:premium.button') }}
                                </a>

                            </div>
                        </div>
                    </div>

                    <!--  Column 3 -->
                    <div class="column content column-center">
                        <div class="uptin-pricing-box">
                            <div class="column is-centered column-center" style="padding-top: 2em">
                                <h4 class="title is-size-4 has-text-centered-mobile uptin-text-center">
                                    {{ $t('tariff:enterprises.title') }}
                                </h4>
                            </div>

                            <div class="column is-centered column-center">
                                <p class="uptin-text-center has-text-centered-mobile uptin-text-7 text-gray">
                                    {{ $t('tariff:enterprises.comment') }}
                                </p>
                            </div>

                            <div class="column is-centered column-center has-padding-2x">
                                <p class="title is-size-4 uptin-text-center has-text-centered-mobile">
                                    {{ $t('tariff:enterprises.price') }}
                                </p>
                                <p class="uptin-text-center is-size-7 has-text-centered-mobile text-gray">
                                    {{ $t('tariff:enterprises.unit') }}
                                </p>
                            </div>

                            <div class="column is-centered column-center has-padding-2x is-centered-container">
                                <router-link :to="'contact-us'" class="button uptin-splash-button-linear text-blue" active-class="is-active is-active--advertiser">
                                    {{ $t('tariff:enterprises.button') }}
                                </router-link>
                            </div>

                            <div class="is-centered column-center has-border-bottom-gray">

                            </div>

                            <div class="columns include-style">
                                {{ $t('tariff:enterprises.include') }}
                                <ul style="margin-top: 2em; margin-left: 0">
                                    <li class="uptin-text-6">{{ $t('tariff:enterprises.f1') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:enterprises.f2') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:enterprises.f3') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:enterprises.f4') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:enterprises.f5') }}</li>
                                    <li class="uptin-text-6">{{ $t('tariff:enterprises.f6') }}</li>
                                </ul>
                            </div>

                            <div class="is-centered column-center has-border-bottom-gray">

                            </div>

                            <div class="column is-centered column-center has-padding-2x is-centered-container">
                                <router-link :to="'contact-us'" class="button uptin-splash-button-linear text-blue" active-class="is-active is-active--advertiser">
                                    {{ $t('tariff:enterprises.button') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .include-style {
        margin: 2em 1em;
        padding-bottom: 2em;
    }

    .uptin-splash-button-linear {
        width: 14em;
        height: 2.8em;
        background-size: 1800% 1800%;
        overflow: hidden;
        animation: rainbow 10s ease infinite;
        border-radius: 0.7em;
        border: 2px solid #165ffb;
    }

    .uptin-pricing-box {
        max-width: 500px;
        min-width: 350px;
        background-color: white;
        margin: 10px;
        padding: 10px;
        border-radius: 1em;
        -webkit-box-shadow: 0 0 32px -8px rgba(23,24,26,0.28);
        -moz-box-shadow: 0 0 32px -8px rgba(23,24,26,0.28);
        box-shadow: 0 0 32px -8px rgba(23,24,26,0.28);

        &.mobile-screen {
            min-width: 300px;
        }
    }

    .tariff-page-img {
        max-width: 300px;
        min-width: 300px;
        margin: 2%;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

    .tariff-splash {
        max-width: 900px;
        min-width: 900px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

    .tariff-text {
        text-align: justify;
        text-justify: inter-word;
    }

</style>

<script>
    export default {
        components: {
        },
        name: 'uptin-tariff',
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
